var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#play-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.576v-21.4A1.89 1.89 0 0 1 1.048.477l12.226 12.395-12.23 12.4A1.89 1.89 0 0 1 0 23.576Zm17.153-6.772L3.785 24.63 14.328 13.94l2.825 2.864Zm4.155-5.428c.445.345.732.888.732 1.5 0 .602-.278 1.139-.711 1.484l-2.84 1.662-3.107-3.15 3.105-3.148 2.822 1.652ZM3.793 1.123l13.359 7.819-2.823 2.862L3.792 1.123Z",
    fill: "#8CACAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "play-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .477)",
    d: "M0 0h22.04v24.795H0z"
  })))));
};
export default SvgPlayIcon;